import { render } from "./tpr.vue?vue&type=template&id=45e9b53e"
import script from "./tpr.vue?vue&type=script&lang=js"
export * from "./tpr.vue?vue&type=script&lang=js"

import "./tpr.vue?vue&type=style&index=0&id=45e9b53e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__